import { OptionsType, OptionTypeBase } from "react-select";
import styled from "styled-components";
import { CustomPill } from "../../Pill/CustomPill";
import { Icon } from "../../Icon";

const StyledSelectionStack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 190px;
  padding: 8px 12px !important;
  overflow-y: scroll;
  border-bottom: 1px solid var(--color-primary-200);

  /* adds visual feedback on the close icon */
  span:hover {
    svg path {
      fill: #000;
    }
  }
`;

type SelectionStackProps = {
  selectedOptions: OptionsType<OptionTypeBase>;
  onClearValue: (option: OptionTypeBase) => void;
};

export const SelectionStack = ({
  selectedOptions = [],
  onClearValue,
}: SelectionStackProps) => (
  <StyledSelectionStack data-testid="SelectionStack">
    {selectedOptions.map((option) => (
      <CustomPill
        bgColor="var(--color-secondary-200)"
        color="var(--color-primary-900)"
        key={option.value}
      >
        {option.label}
        <Icon
          iconName="close"
          iconSize="small"
          plain
          cursor="pointer"
          type="default"
          onClick={() => {
            onClearValue(option);
          }}
        />
      </CustomPill>
    ))}
  </StyledSelectionStack>
);
